import React from "react";
import { Icon, Title } from "components/common";
import PageLayout from "components/common/pageLayout/pageLayout";
import styles from "./ComingSoon.module.less";

const ComingSoon = ({ 
  title = "Coming Soon", 
  description = "We're working hard to bring you something amazing!", 
  icon = "MdHourglassTop"
}) => {
  return (
    <PageLayout 
      backIcon={true} 
      label={<Title level={2} style={{ margin: 0 }}>{title}</Title>}
    >
      <div className={styles.comingSoonContainer}>
        <div className={styles.content}>
          <div className={styles.textCenter}>
            {/* Animated Icon */}
            <div className={styles.iconContainer}>
              <Icon 
                icon={icon} 
                size={100} 
                className={styles.comingSoonIcon}
              />
              <div className={styles.iconGlow}></div>
            </div>

            {/* Title */}
            <Title level={1} className={styles.title}>
              {title}
            </Title>

            {/* Description */}
            <p className={styles.description}>
              {description}
            </p>

            {/* Subtitle */}
            <p className={styles.subtitle}>
              Our team is putting the finishing touches on this feature. 
              It will be available soon with exciting new capabilities!
            </p>

            {/* Features Preview */}
            <div className={styles.featuresPreview}>
              <div className={styles.featureItem}>
                <Icon icon="FiCheckCircle" size={20} />
                <span>Modern Interface</span>
              </div>
              <div className={styles.featureItem}>
                <Icon icon="FiCheckCircle" size={20} />
                <span>Enhanced Performance</span>
              </div>
              <div className={styles.featureItem}>
                <Icon icon="FiCheckCircle" size={20} />
                <span>Improved User Experience</span>
              </div>
            </div>
          </div>
        </div>

        {/* Floating Animation Elements */}
        <div className={styles.floatingElements}>
          <div className={styles.floatingElement}></div>
          <div className={styles.floatingElement}></div>
          <div className={styles.floatingElement}></div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ComingSoon;
